<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" :class="classObj" class="app-wrapper">
    <navbar v-show="!fullScreenType" />
    <div v-if="device === 'mobile' && sidebar.opened" v-show="!fullScreenType" class="drawer-bg" @click="handleClickOutside" />
    <sidebar v-show="!fullScreenType" class="sidebar-container" />
    <el-dialog
      custom-class="xigua-player"
      :visible="$store.getters.xiGuaPlayer.playerDialog"
      :title="$store.getters.xiGuaPlayer.title"
      :width="dialogWidth"
      :before-close="
        () => {
          $store.dispatch('xiGuaPlayer/pause')
        }
      "
      :close-on-click-modal="true"
      :append-to-body="true"
      top="5vh"
    >
      <div />
      <template #footer>
        <div class="player-content" style="flex: 1;">
          <div id="xigua-play" />
        </div>
        <div v-if="$store.getters.xiGuaPlayer.signature" class="video-analyse-content">
          <video-analyse :file-data="fileData" :play-dom="$store.getters.xiGuaPlayer.player" :reload-analyse="false" :video-analyse-tabs-loaidng="videoAnalyseTabsLoaidng" />
        </div>
        <div v-if="$store.getters.xiGuaPlayer.wordData.materialName" class="word-frame-content">
          <WordFrame></WordFrame>
        </div>
      </template>
    </el-dialog>
    <div class="main-container">
      <div v-show="!fullScreenType" :class="{ 'fixed-header': fixedHeader }">
        <tags-view />
      </div>
      <app-main ref="appMain" :class="{ 'full-screen-view': fullScreenType }" />
    </div>

    <warning-message :data="messageData" />
    <ResetLogin />
    <FloatingBall v-if="floatingBallVisble" />
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, TagsView, FloatingBall } from './components'
import warningMessage from './warningMessage'
import ResetLogin from './ResetLogin'
import ResizeMixin from './mixin/ResizeHandler'
import { toFixed, parseTime } from '@/utils'
import VideoAnalyse from '@/views/dsp/material/component/VideoAnalyse'
import WordFrame from '@/views/dsp/adanalysis/component/WordFrame'
import { getDeconstructBySignature } from '@/api/dsp/file'
const Base64 = require('js-base64').Base64
export default {
  name: 'Layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    TagsView,
    warningMessage,
    ResetLogin,
    FloatingBall,
    VideoAnalyse,
    WordFrame
  },
  mixins: [ResizeMixin],
  data() {
    return {
      warningShow: false,
      warningIndex: 0,
      tableHeight: '500px',
      fullscreenLoading: false,
      messageData: {},
      fullScreenType: false,
      videoAnalyseTabsLoaidng: false,
      fileData: {}
    }
  },
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    fixedHeader() {
      return this.$store.state.settings.fixedHeader
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    },
    floatingBallVisble() {
      const visibleModel = ['dsp', 'dms', 'admin', 'guide']
      const model = this.$route.path.split('/')[1]
      return visibleModel.includes(model)
    },
    dialogWidth() {
      const hasWordData = this.$store.getters.xiGuaPlayer.wordData && Object.keys(this.$store.getters.xiGuaPlayer.wordData).length > 0
      if (this.$store.getters.xiGuaPlayer.signature || hasWordData) {
        return '90%'
      }
      return this.$global.isPC ? '60%' : '90%'
    }
  },
  watch: {
    '$store.getters.ws_message': function(response) {
      const data = response.data
      if (data.notice_type === 5) {
        this.messageData = data
      } else if (data.notice_type === 7) {
        this.logout() // 用户被删除，强制退出
      }
    },
    '$store.getters.fullScreenType': function(type) {
      this.fullScreenType = type
    },
    '$store.getters.xiGuaPlayer.signature': function(signature) {
      if (signature) {
        this.getDeconstructBySignature([signature])
      } else {
        this.fileData = null
      }
    }
  },
  created() {
    const state = localStorage.getItem('menuDefaultState') || 'close' // 获取个人中心设置
    if (state === 'open') {
      this.$store.dispatch('app/openSideBar', { withoutAnimation: false })
    } else if (state === 'close') {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    }
    this.$store.dispatch('websocket/init')
    this.keyupWatch()
    this.watchFullScreen()
    const platformMap = Base64.decode(this.$store.getters.platform_map)
    this.$global.platformMap = JSON.parse(platformMap)
    console.log(this.$global.platformMap)
    if (this.$store.getters.plat_map) {
      const platMap = JSON.parse(Base64.decode(this.$store.getters.plat_map))
      this.$global.platIdMap = Object.keys(platMap).map(key => {
        return { label: platMap[key], value: Number(key) }
      })
    }
  },
  methods: {
    toFixed,
    parseTime,
    keyupWatch() {
      document.addEventListener('keydown', e => {
        const key = e.which || e.keyCode
        this.keyCode += key + ''
        setTimeout(() => {
          if (this.keyCode.indexOf('1766') === -1) {
            this.keyCode = ''
          }
        }, 500)
        if (this.keyCode.indexOf('1766') > -1) {
          this.fullScreen()
          this.keyCode = ''
        }
      })
    },
    watchFullScreen() {
      document.addEventListener('fullscreenchange', () => {
        this.fullScreenType = document.fullscreen
      })
      document.addEventListener('mozfullscreenchange', () => {
        this.fullScreenType = document.mozFullScreen
      })
      document.addEventListener('webkitfullscreenchange', () => {
        this.fullScreenType = document.webkitIsFullScreen
      })
      document.addEventListener('msfullscreenchange', () => {
        this.fullScreenType = document.msFullscreenElement
      })
    },
    fullScreen() {
      this.fullScreenLoading = true
      const dom = document.body
      if (dom) {
        try {
          if (dom.requestFullscreen) {
            dom.requestFullscreen()
          } else if (dom.webkitRequestFullScreen) {
            dom.webkitRequestFullScreen()
          } else if (dom.mozRequestFullScreen) {
            dom.mozRequestFullScreen()
          } else if (dom.msRequestFullscreen) {
            // IE11
            dom.msRequestFullscreen()
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },

    async logout() {
      this.fullscreenLoading = true

      await this.$store.dispatch('websocket/close')

      await this.$store.dispatch('user/logout')
      // 删除缓存的标签
      await this.$store.dispatch('tagsView/delAllViews')

      this.fullscreenLoading = false

      this.$router.push(`/login`)
      location.reload(true)
    },
    getDeconstructBySignature(signature) {
      this.videoAnalyseTabsLoaidng = true
      getDeconstructBySignature({ signature })
        .then(res => {
          this.fileData = res.data[0]
        })
        .finally(() => {
          this.videoAnalyseTabsLoaidng = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
@import '~@/styles/variables.scss';

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.drawer-bg {
  background: #000;
  opacity: 0.3;
  width: 100%;
  top: 0;
  height: 100%;
  position: absolute;
  z-index: 999;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - #{$sideBarWidth});
  transition: width 0.28s;
}

.hideSidebar .fixed-header {
  width: calc(100% - 54px);
}

.mobile .fixed-header {
  width: 100%;
}
@media (max-height: 1000px) and (max-width: 1000px) {
  .navbar {
    position: relative;
  }
  .main-container {
    padding-top: 0 !important;
    min-height: calc(100vh - 84px) !important;
  }
}

>>> .xigua-player {
  .el-dialog__body {
    display: none;
  }

  .el-dialog__footer {
    display: flex;

    .video-analyse-content {
      width: 38%;
      padding-left: 20px;
    }
    .word-frame-content {
      width: 38%;
      padding-left: 20px;
    }
  }
}
</style>
